export const Config = class createToken {
      constructor() {
          var production = false;
          if(production){
              this.apibaseurl = 'vlitevendor.mobiotics.com';
              this.vendorportalurl = 'vlite.mobiotics.com';
              this.stripelogo = 'vlite.mobiotics.com/largeimage/vLiteLogo.png';
              this.largeimage = 'vlite.mobiotics.com/largeimage';
          }else{
              this.apibaseurl = 'vlitetest.mobiotics.com';
              this.vendorportalurl = 'vlitetest.mobiotics.com/vendorui/ui';
              this.stripelogo = 'vliteprelaunchtest.mobiotics.com/largeimage/vLiteLogo.png';
              this.largeimage = 'vliteprelaunchtest.mobiotics.com/largeimage';
          }
      }
      getApiUrl(){
          return window.location.protocol+'//'+this.apibaseurl;
      }
      getPortalUrl(){
          return window.location.protocol+'//'+this.vendorportalurl;
      }
      getStripeLogo(){
          return window.location.protocol+'//'+this.stripelogo;
      }
      getlargeImgPath(){
          return window.location.protocol+'//'+this.largeimage;
      }
}



// WEBPACK FOOTER //
// ./src/assets/js/config.js